import { useDispatch, useSelector } from "react-redux";
import { useAuth0 } from "@auth0/auth0-react";
import {
  setCredentialManagementShareUsersModalOpen,
  clearCredentialsManagementShareSelectedUsers
} from "redux/actions/portal/credentialManagementActionCreator";
import SoftButton from "components/SoftButton";
import DialogActions from "@mui/material/DialogActions";
import { shareCredential } from "api/CredentialManagementApi";
import { setCredentials } from "redux/actions/portal/credentialManagementActionCreator";
import { toast } from "react-toastify";

const CredentialsDialogActions = () => {
  const { user } = useAuth0();
  const dispatch = useDispatch();
  const { credentialManangementShareSelectedUsers, selectedCredential, credentials } = useSelector(
    (store) => store.portal.credentialManagement
  );

  const handleShareCredential = async () => {
    try {
      const input = {
        tenantId: user?.stripeId,
        users: credentialManangementShareSelectedUsers,
        credential: selectedCredential
      };

      const shareCredentialResponse = await shareCredential(input);
      if (shareCredentialResponse?.isSuccessful) {
        toast.success("User credentials shared successfully");
        const updatedCredentials = credentials.map((credential) => {
          if (credential.id === selectedCredential.id) {
            return input.credential;
          }
          return credential;
        });
        dispatch(setCredentials(updatedCredentials || []));
      } else {
        toast.error(shareCredentialResponse.message);
      }
      dispatch(clearCredentialsManagementShareSelectedUsers());
      handleCredentialManangementUsersModalClose();
    } catch (error) {
      console.error("share credential error:", error);
    }
  };

  const handleCredentialManangementUsersModalClose = () => {
    if (credentialManangementShareSelectedUsers.length > 0) {
      dispatch(clearCredentialsManagementShareSelectedUsers());
    }
    dispatch(setCredentialManagementShareUsersModalOpen(false));
  };

  return (
    <DialogActions>
      <SoftButton
        onClick={handleCredentialManangementUsersModalClose}
        color="primary"
        variant="outlined"
      >
        Cancel
      </SoftButton>
      <SoftButton
        onClick={handleShareCredential}
        color="primary"
        disabled={credentialManangementShareSelectedUsers.length === 0}
      >
        Share
      </SoftButton>
    </DialogActions>
  );
};

export default CredentialsDialogActions;
